// import { useState, useMemo, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';

// /* ─── Types ─── */
// interface LookbookCategory {
//   id: string;
//   label: string;
// }

// interface LookbookPhoto {
//   id: string;
//   category: string;
//   categoryLabel: string;
//   title: string;
//   description: string;
//   src: string;
// }

// /* ─── Data (single source of truth) ─── */
// const shop = {
//   name: '헤리츠테일러 청담본점',
// };

// const categories: LookbookCategory[] = [
//   { id: 'all', label: '전체' },
//   { id: 'bespoke', label: '맞춤 예복' },
//   { id: 'rental', label: '대여 예복' },
//   { id: 'accessory', label: '악세사리&소품' },
//   // { id: 'store', label: '매장 사진' },
// ];
// const lookbook1 = [
//   '/resources/detail/shop/heritz/lookbook_05.jpg',
//   '/resources/detail/shop/heritz/lookbook_06.jpg',
//   '/resources/detail/shop/heritz/lookbook_07.jpg',
//   '/resources/detail/shop/heritz/lookbook_08.jpg',
//   '/resources/detail/shop/heritz/lookbook_09.jpg',
// ]

// const lookbook2 = [
//   '/resources/detail/shop/heritz/lookbook_05.jpg',
//   '/resources/detail/shop/heritz/lookbook_06.jpg',
//   '/resources/detail/shop/heritz/lookbook_07.jpg',
//   '/resources/detail/shop/heritz/lookbook_08.jpg',
//   '/resources/detail/shop/heritz/lookbook_09.jpg',
// ]


// const lookbook3 = [
//   '/resources/detail/shop/heritz/lookbook_05.jpg',
//   '/resources/detail/shop/heritz/lookbook_06.jpg',
//   '/resources/detail/shop/heritz/lookbook_07.jpg',
//   '/resources/detail/shop/heritz/lookbook_08.jpg',
//   '/resources/detail/shop/heritz/lookbook_09.jpg',
// ]

// const photosOrg: LookbookPhoto[] = [
//   {
//     id: 'lb-01',
//     category: 'bespoke',
//     categoryLabel: '맞춤 예복',
//     title: '프리미엄 네이비 맞춤 예복',
//     description: '이탈리안 울 100% 원단으로 제작한 네이비 맞춤 예복. 촬영과 본식 모두에 어울리는 클래식한 실루엣을 강조합니다.',
//     src: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20groom%20in%20premium%20navy%20bespoke%20suit%20full%20body%20portrait%20soft%20natural%20window%20light%20editorial%20wedding%20photography%20warm%20cream%20background%20luxury%20menswear%20quiet%20sophistication%20high-end%20magazine%20cover%20quality&width=800&height=1000&seq=lb-01&orientation=portrait',
//   },
//   {
//     id: 'lb-02',
//     category: 'bespoke',
//     categoryLabel: '맞춤 예복',
//     title: '차콜 그레이 맞춤 예복',
//     description: '딥 차콜 그레이 컬러의 맞춤 예복으로 세련된 모던 느낌을 연출합니다.',
//     src: 'https://readdy.ai/api/search-image?query=Korean%20groom%20in%20charcoal%20grey%20bespoke%20suit%20full%20body%20portrait%20modern%20minimalist%20studio%20background%20editorial%20fashion%20photography%20luxury%20menswear%20soft%20warm%20lighting%20elegant%20pose&width=800&height=1000&seq=lb-02&orientation=portrait',
//   },
//   {
//     id: 'lb-03',
//     category: 'bespoke',
//     categoryLabel: '맞춤 예복',
//     title: '클래식 블랙 턱시도',
//     description: '웨딩 본식에 최적화된 블랙 턱시도. 새틴 라펠과 보타이가 클래식한 무드를 완성합니다.',
//     src: 'https://readdy.ai/api/search-image?query=Korean%20groom%20in%20classic%20black%20tuxedo%20with%20satin%20lapel%20full%20body%20portrait%20elegant%20white%20studio%20background%20editorial%20wedding%20photography%20luxury%20menswear%20soft%20warm%20lighting&width=800&height=1000&seq=lb-03&orientation=portrait',
//   },
//   {
//     id: 'lb-04',
//     category: 'bespoke',
//     categoryLabel: '맞춤 예복',
//     title: '브라운 맞춤 예복',
//     description: '따뜻한 브라운 톤의 맞춤 예복. 가을 웨딩에 특히 잘 어울리는 컬러입니다.',
//     src: 'https://readdy.ai/api/search-image?query=Korean%20groom%20in%20premium%20brown%20bespoke%20suit%20full%20body%20portrait%20soft%20warm%20hotel%20interior%20lighting%20editorial%20wedding%20photography%20luxury%20menswear%20autumn%20tones%20elegant%20pose&width=800&height=1000&seq=lb-04&orientation=portrait',
//   },
//   {
//     id: 'lb-05',
//     category: 'bespoke',
//     categoryLabel: '맞춤 예복',
//     title: '피팅 중인 맞춤 예복',
//     description: '헤리츠테일러의 전문 피터가 1:1 피팅을 진행합니다. 세밀한 핏 조정이 가능합니다.',
//     src: 'https://readdy.ai/api/search-image?query=Korean%20groom%20fitting%20session%20at%20luxury%20bespoke%20tailor%20atelier%20mirror%20reflection%20adjusting%20jacket%20collar%20soft%20warm%20light%20editorial%20wedding%20preparation%20menswear%20photography&width=800&height=1000&seq=lb-05&orientation=portrait',
//   },
//   {
//     id: 'lb-06',
//     category: 'bespoke',
//     categoryLabel: '맞춤 예복',
//     title: '수트 자수 디테일',
//     description: '정교한 손자수 디테일이 특징인 맞춤 예복. 헤리츠테일러만의 기술력을 보여줍니다.',
//     src: 'https://readdy.ai/api/search-image?query=Premium%20bespoke%20suit%20detail%20shot%20lapel%20collar%20buttonhole%20embroidery%20stitching%20close-up%20soft%20golden%20ambient%20light%20luxury%20menswear%20editorial%20product%20photography%20warm%20tones&width=800&height=1000&seq=lb-06&orientation=portrait',
//   },
//   {
//     id: 'lb-07',
//     category: 'rental',
//     categoryLabel: '대여 예복',
//     title: '네이비 대여 턱시도',
//     description: '촬영용으로 인기 있는 네이비 대여 턱시도. 깔끔한 핏과 질감이 특징입니다.',
//     src: 'https://readdy.ai/api/search-image?query=Korean%20groom%20in%20navy%20rental%20tuxedo%20full%20body%20portrait%20modern%20white%20studio%20background%20editorial%20fashion%20photography%20wedding%20menswear%20soft%20lighting%20clean%20elegant&width=800&height=1000&seq=lb-07&orientation=portrait',
//   },
//   {
//     id: 'lb-08',
//     category: 'rental',
//     categoryLabel: '대여 예복',
//     title: '그레이 대여 예복',
//     description: '모던한 그레이 컬러의 대여 예복. 다양한 촬영 콘셉트에 매치하기 좋습니다.',
//     src: 'https://readdy.ai/api/search-image?query=Korean%20groom%20in%20grey%20rental%20wedding%20suit%20full%20body%20portrait%20modern%20minimalist%20background%20editorial%20fashion%20photography%20menswear%20soft%20warm%20lighting%20elegant&width=800&height=1000&seq=lb-08&orientation=portrait',
//   },
//   {
//     id: 'lb-09',
//     category: 'rental',
//     categoryLabel: '대여 예복',
//     title: '클래식 블랙 대여 턱시도',
//     description: '깔끔한 블랙 대여 턱시도. 본식과 촬영 모두 활용할 수 있는 베이직 아이템입니다.',
//     src: 'https://readdy.ai/api/search-image?query=Korean%20groom%20in%20classic%20black%20rental%20tuxedo%20full%20body%20portrait%20clean%20white%20studio%20background%20editorial%20fashion%20photography%20wedding%20menswear%20soft%20lighting%20elegant&width=800&height=1000&seq=lb-09&orientation=portrait',
//   },
//   {
//     id: 'lb-10',
//     category: 'rental',
//     categoryLabel: '대여 예복',
//     title: '화이트 디너 재킷',
//     description: '특별한 촬영을 위한 화이트 디너 재킷 대여 옵션. 세미 포멀한 무드를 연출합니다.',
//     src: 'https://readdy.ai/api/search-image?query=Korean%20groom%20in%20white%20dinner%20jacket%20tuxedo%20full%20body%20portrait%20elegant%20studio%20background%20editorial%20fashion%20photography%20wedding%20menswear%20soft%20warm%20lighting&width=800&height=1000&seq=lb-10&orientation=portrait',
//   },
//   {
//     id: 'lb-11',
//     category: 'accessory',
//     categoryLabel: '악세사리&소품',
//     title: '보타이 & 커프링크스 세트',
//     description: '실크 보타이와 커프링크스 매치 세트. 컬러별 다양한 구성이 준비되어 있습니다.',
//     src: 'https://readdy.ai/api/search-image?query=Luxury%20silk%20bow%20ties%20and%20cufflinks%20collection%20flat%20lay%20arrangement%20on%20warm%20cream%20background%20editorial%20product%20photography%20menswear%20accessories%20soft%20lighting%20elegant&width=800&height=1000&seq=lb-11&orientation=portrait',
//   },
//   {
//     id: 'lb-12',
//     category: 'accessory',
//     categoryLabel: '악세사리&소품',
//     title: '브라운 레더 드레스 슈즈',
//     description: '이탈리안 수제 브라운 레더 드레스 슈즈. 맞춤 예복과 함께 착용하는 것을 추천합니다.',
//     src: 'https://readdy.ai/api/search-image?query=Premium%20Italian%20brown%20leather%20dress%20shoes%20product%20shot%20on%20warm%20cream%20background%20editorial%20menswear%20photography%20soft%20lighting%20elegant%20craftsmanship%20detail&width=800&height=1000&seq=lb-12&orientation=portrait',
//   },
//   {
//     id: 'lb-13',
//     category: 'accessory',
//     categoryLabel: '악세사리&소품',
//     title: '포켓 스퀘어 컬렉션',
//     description: '다양한 패턴과 컬러의 포켓 스퀘어 컬렉션. 예복 포인트로 활용할 수 있습니다.',
//     src: 'https://readdy.ai/api/search-image?query=Luxury%20pocket%20squares%20collection%20flat%20lay%20various%20patterns%20silk%20fabrics%20on%20warm%20cream%20background%20editorial%20menswear%20accessories%20product%20photography%20soft%20lighting&width=800&height=1000&seq=lb-13&orientation=portrait',
//   },
//   {
//     id: 'lb-14',
//     category: 'store',
//     categoryLabel: '매장 사진',
//     title: '청담 쇼룸 전경',
//     description: '헤리츠테일러 청담본점 쇼룸. 프라이빗한 상담 공간과 다양한 원단을 전시하고 있습니다.',
//     src: 'https://readdy.ai/api/search-image?query=Luxury%20Korean%20bespoke%20tailoring%20atelier%20showroom%20interior%20warm%20ambient%20light%20wooden%20shelves%20fabric%20rolls%20display%20elegant%20minimalist%20space%20cream%20palette%20premium%20menswear%20shop&width=800&height=1000&seq=lb-14&orientation=portrait',
//   },
//   {
//     id: 'lb-15',
//     category: 'store',
//     categoryLabel: '매장 사진',
//     title: '원단 전시 공간',
//     description: '다양한 이탈리안 원단을 직접 보고 만져볼 수 있는 전시 공간입니다.',
//     src: 'https://readdy.ai/api/search-image?query=Premium%20Italian%20wool%20fabric%20rolls%20display%20shelves%20in%20luxury%20tailoring%20atelier%20warm%20ambient%20light%20wooden%20interior%20editorial%20space%20photography%20menswear%20shop%20elegant&width=800&height=1000&seq=lb-15&orientation=portrait',
//   },
//   {
//     id: 'lb-16',
//     category: 'store',
//     categoryLabel: '매장 사진',
//     title: '프라이빗 피팅룸',
//     description: '넓은 프라이빗 피팅룸에서 여유롭게 예복 피팅을 진행할 수 있습니다.',
//     src: 'https://readdy.ai/api/search-image?query=Luxury%20private%20fitting%20room%20in%20bespoke%20tailoring%20atelier%20full%20length%20mirror%20warm%20ambient%20light%20elegant%20wooden%20interior%20cream%20palette%20menswear%20shop%20editorial%20photography&width=800&height=1000&seq=lb-16&orientation=portrait',
//   },
// ];

// const photos = photosOrg.map((p, idx) => ({
//   ...p,
//   id: `photo-${idx + 1}`,
//   src: p.category === 'bespoke' ? lookbook1[idx % lookbook1.length] : p.category === 'rental' ? lookbook1[idx % lookbook2.length] : p.category === 'accessory' ? lookbook3[idx % lookbook3.length] : p.src,
// }));
// /* ─── Helper ─── */
// function getCategoryCount(catId: string) {
//   if (catId === 'all') return photos.length;
//   return photos.filter((p) => p.category === catId).length;
// }

// /* ─── Sub-components (presentational only) ─── */
// function LookbookHeader({
//   onBack,
//   onShare,
//   title,
// }: {
//   onBack: () => void;
//   onShare: () => void;
//   title: string;
// }) {
//   return (
//     <>
//       {/* Mobile */}
//       <div className="lg:hidden shrink-0 h-14 flex items-center justify-between px-4 bg-white border-b border-[#E8E2DA]">
//         <button
//           onClick={onBack}
//           className="w-10 h-10 flex items-center justify-center text-[#121B35] active:scale-90 transition-transform"
//           aria-label="뒤로가기"
//         >
//           <i className="ri-arrow-left-s-line text-xl" />
//         </button>
//         <span className="absolute left-1/2 -translate-x-1/2 text-[15px] font-semibold text-[#121B35] truncate max-w-[60%]">
//           {title}
//         </span>
//         <button
//           onClick={onShare}
//           className="w-10 h-10 flex items-center justify-center text-[#121B35] active:scale-90 transition-transform"
//           aria-label="공유하기"
//         >
//           <i className="ri-share-line text-lg" />
//         </button>
//       </div>

//       {/* Desktop */}
//       <div className="hidden lg:block shrink-0 h-16 bg-white border-b border-[#E8E2DA]">
//         <div className="max-w-[1200px] mx-auto px-6 h-full flex items-center justify-between">
//           <div className="flex items-center gap-3">
//             <button
//               onClick={onBack}
//               className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-[#F7F2EA] transition-colors"
//             >
//               <i className="ri-close-line text-xl text-[#121B35]" />
//             </button>
//             <h1 className="text-[17px] font-semibold text-[#121B35]">{title}</h1>
//           </div>
//           <button
//             onClick={onShare}
//             className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-[#F7F2EA] transition-colors"
//           >
//             <i className="ri-share-line text-lg text-[#121B35]" />
//           </button>
//         </div>
//       </div>
//     </>
//   );
// }

// function CategoryFilter({
//   categories: cats,
//   activeCategory,
//   onChange,
//   onToggleGrid,
//   isGrid,
// }: {
//   categories: LookbookCategory[];
//   activeCategory: string;
//   onChange: (id: string) => void;
//   onToggleGrid: () => void;
//   isGrid: boolean;
// }) {
//   return (
//     <div className="shrink-0 bg-white border-b border-[#E8E2DA]">
//       <div className="max-w-[1200px] mx-auto px-4 lg:px-6 h-12 flex items-center justify-between">
//         <div className="flex gap-2 overflow-x-auto scrollbar-hide items-center">
//           {cats.map((cat) => {
//             const count = getCategoryCount(cat.id);
//             const isActive = activeCategory === cat.id;
//             return (
//               <button
//                 key={cat.id}
//                 onClick={() => onChange(cat.id)}
//                 className={`shrink-0 px-3 py-1.5 rounded-full text-[13px] font-medium transition-colors whitespace-nowrap ${
//                   isActive
//                     ? 'bg-[#121B35] text-white'
//                     : 'text-[#536079] hover:text-[#121B35]'
//                 }`}
//               >
//                 {cat.label}
//                 <span
//                   className={`ml-1 ${
//                     isActive ? 'text-[#B9965B]' : 'text-[#9AA3B2]'
//                   }`}
//                 >
//                   {count}
//                 </span>
//               </button>
//             );
//           })}
//         </div>
//         <button
//           onClick={onToggleGrid}
//           className="shrink-0 ml-3 flex items-center gap-1 text-[13px] text-[#536079] hover:text-[#121B35] transition-colors whitespace-nowrap"
//         >
//           <i className={`ri-${isGrid ? 'image-line' : 'grid-fill'} text-sm`} />
//           {isGrid ? '사진 보기' : '전체보기'}
//         </button>
//       </div>
//     </div>
//   );
// }

// function PhotoViewer({
//   photo,
//   currentIndex,
//   totalCount,
//   filteredPhotos,
//   onPrev,
//   onNext,
//   onThumbnailClick,
// }: {
//   photo: LookbookPhoto;
//   currentIndex: number;
//   totalCount: number;
//   filteredPhotos: LookbookPhoto[];
//   onPrev: () => void;
//   onNext: () => void;
//   onThumbnailClick: (idx: number) => void;
// }) {
//   return (
//     <div className="flex-1 min-h-0 flex flex-col lg:flex-row lg:overflow-hidden">
//       {/* Image viewer area */}
//       <div className="flex-1 min-h-0 relative bg-[#F9F6F0]">
//         <img
//           src={photo.src}
//           alt={photo.title}
//           className="w-full h-full object-contain"
//           draggable={false}
//         />

//         {/* Count badge */}
//         <div className="absolute top-3 right-3 bg-black/50 text-white text-[13px] px-3 py-1 rounded-full font-medium">
//           {currentIndex + 1} / {totalCount}
//         </div>

//         {/* Prev */}
//         {totalCount > 1 && (
//           <button
//             onClick={onPrev}
//             className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-white/80 hover:bg-white rounded-full text-[#121B35] transition-colors shadow-sm"
//             aria-label="이전 사진"
//           >
//             <i className="ri-arrow-left-s-line text-lg" />
//           </button>
//         )}

//         {/* Next */}
//         {totalCount > 1 && (
//           <button
//             onClick={onNext}
//             className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-white/80 hover:bg-white rounded-full text-[#121B35] transition-colors shadow-sm"
//             aria-label="다음 사진"
//           >
//             <i className="ri-arrow-right-s-line text-lg" />
//           </button>
//         )}
//       </div>

//       {/* Mobile info panel — compact */}
//       <div className="shrink-0 lg:hidden bg-white border-t border-[#E8E2DA]">
//         <div className="px-4 py-3">
//           <div className="flex items-center gap-2 mb-1">
//             <span className="bg-[#F7F2EA] text-[#121B35] text-[11px] px-2.5 py-0.5 rounded-full font-medium">
//               {photo.categoryLabel}
//             </span>
//           </div>
//           <h3 className="text-[15px] font-semibold text-[#121B35] leading-snug">
//             {photo.title}
//           </h3>
//           <p className="text-[13px] text-[#536079] leading-[1.6] mt-0.5 line-clamp-2">
//             {photo.description}
//           </p>
//         </div>

//         {/* Thumbnail strip */}
//         <div className="px-4 pb-3">
//           <div className="flex gap-2 overflow-x-auto scrollbar-hide">
//             {filteredPhotos.map((p, i) => (
//               <button
//                 key={p.id}
//                 onClick={() => onThumbnailClick(i)}
//                 className={`shrink-0 w-12 h-12 rounded-md overflow-hidden transition-all ${
//                   i === currentIndex
//                     ? 'ring-2 ring-[#121B35]'
//                     : 'opacity-60 hover:opacity-100'
//                 }`}
//               >
//                 <img src={p.src} alt={p.title} className="w-full h-full object-cover" />
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Desktop info panel */}
//       <div className="hidden lg:block w-[340px] shrink-0 bg-white border-l border-[#E8E2DA] overflow-y-auto">
//         <div className="p-5">
//           <div className="flex items-center gap-2 mb-3">
//             <span className="bg-[#F7F2EA] text-[#121B35] text-xs px-2.5 py-1 rounded-full font-medium">
//               {photo.categoryLabel}
//             </span>
//           </div>
//           <h3 className="text-lg font-semibold text-[#121B35] leading-snug">
//             {photo.title}
//           </h3>
//           <p className="text-sm text-[#536079] leading-[1.7] mt-2">
//             {photo.description}
//           </p>
//         </div>

//         <div className="px-5 pb-5">
//           <p className="text-[11px] font-medium text-[#536079] mb-2">같은 카테고리 사진</p>
//           <div className="flex flex-wrap gap-2">
//             {filteredPhotos.map((p, i) => (
//               <button
//                 key={p.id}
//                 onClick={() => onThumbnailClick(i)}
//                 className={`w-14 h-14 rounded-md overflow-hidden transition-all ${
//                   i === currentIndex
//                     ? 'ring-2 ring-[#121B35]'
//                     : 'opacity-60 hover:opacity-100'
//                 }`}
//               >
//                 <img src={p.src} alt={p.title} className="w-full h-full object-cover" />
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// function PhotoGrid({
//   photos: gridPhotos,
//   onPhotoClick,
//   currentPhotoId,
// }: {
//   photos: LookbookPhoto[];
//   onPhotoClick: (photo: LookbookPhoto) => void;
//   currentPhotoId: string;
// }) {
//   return (
//     <div className="flex-1 min-h-0 overflow-y-auto bg-[#F7F2EA]">
//       <div className="max-w-[1200px] mx-auto px-4 lg:px-6 py-4">
//         <div className="grid grid-cols-3 lg:grid-cols-5 gap-1.5 lg:gap-2">
//           {gridPhotos.map((photo) => (
//             <button
//               key={photo.id}
//               onClick={() => onPhotoClick(photo)}
//               className={`relative aspect-square rounded-lg overflow-hidden bg-[#E8E2DA] transition-all ${
//                 photo.id === currentPhotoId ? 'ring-2 ring-[#121B35]' : ''
//               }`}
//             >
//               <img
//                 src={photo.src}
//                 alt={photo.title}
//                 className="w-full h-full object-cover"
//               />
//               <span className="absolute bottom-1 left-1 bg-black/50 text-white text-[10px] px-1.5 py-0.5 rounded">
//                 {photo.categoryLabel}
//               </span>
//             </button>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ─── Main Page ─── */
// export default function LookbookPage() {
//   const navigate = useNavigate();
//   const [activeCategory, setActiveCategory] = useState('all');
//   const [selectedIdx, setSelectedIdx] = useState(0);
//   const [viewMode, setViewMode] = useState<'viewer' | 'grid'>('viewer');

//   const filtered = useMemo(() => {
//     if (activeCategory === 'all') return photos;
//     return photos.filter((p) => p.category === activeCategory);
//   }, [activeCategory]);

//   const current = filtered[selectedIdx] ?? filtered[0] ?? null;

//   const handleCategoryChange = useCallback((id: string) => {
//     setActiveCategory(id);
//     setSelectedIdx(0);
//     setViewMode('viewer');
//   }, []);

//   const handlePrev = useCallback(() => {
//     setSelectedIdx((prev) => (prev - 1 + filtered.length) % filtered.length);
//   }, [filtered.length]);

//   const handleNext = useCallback(() => {
//     setSelectedIdx((prev) => (prev + 1) % filtered.length);
//   }, [filtered.length]);

//   const handleThumbnailClick = useCallback((index: number) => {
//     setSelectedIdx(index);
//   }, []);

//   const handleGridClick = useCallback(
//     (photo: LookbookPhoto) => {
//       const idx = filtered.findIndex((p) => p.id === photo.id);
//       setSelectedIdx(idx >= 0 ? idx : 0);
//       setViewMode('viewer');
//     },
//     [filtered],
//   );

//   const handleToggleGrid = useCallback(() => {
//     setViewMode((prev) => (prev === 'viewer' ? 'grid' : 'viewer'));
//   }, []);

//   const handleBack = useCallback(() => {
//     navigate(-1);
//   }, [navigate]);

//   const handleShare = useCallback(async () => {
//     try {
//       if (navigator.share) {
//         await navigator.share({
//           title: `${shop.name} 브랜드 룩북`,
//           url: window.location.href,
//         });
//       } else {
//         await navigator.clipboard.writeText(window.location.href);
//       }
//     } catch {
//       // noop
//     }
//   }, []);

//   if (!current) {
//     return (
//       <div className="h-[100dvh] flex flex-col bg-[#F7F2EA]">
//         <LookbookHeader
//           onBack={handleBack}
//           onShare={handleShare}
//           title={`${shop.name} 브랜드 룩북`}
//         />
//         <div className="flex-1 flex items-center justify-center text-[#536079] text-sm">
//           룩북 사진이 없습니다.
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="h-[100dvh] flex flex-col overflow-hidden bg-[#F7F2EA]">
//       <LookbookHeader
//         onBack={handleBack}
//         onShare={handleShare}
//         title={`${shop.name} 브랜드 룩북`}
//       />

//       <CategoryFilter
//         categories={categories}
//         activeCategory={activeCategory}
//         onChange={handleCategoryChange}
//         onToggleGrid={handleToggleGrid}
//         isGrid={viewMode === 'grid'}
//       />

//       {viewMode === 'viewer' ? (
//         <PhotoViewer
//           photo={current}
//           currentIndex={selectedIdx}
//           totalCount={filtered.length}
//           filteredPhotos={filtered}
//           onPrev={handlePrev}
//           onNext={handleNext}
//           onThumbnailClick={handleThumbnailClick}
//         />
//       ) : (
//         <PhotoGrid
//           photos={filtered}
//           onPhotoClick={handleGridClick}
//           currentPhotoId={current.id}
//         />
//       )}
//     </div>
//   );
// }

import {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import {
  getPartnerShopLookbookBySlug,
  type LookbookCategory,
  type LookbookPhoto,
  type PartnerShopLookbookData,
} from '@/api/partnerShopDetail';

function LookbookHeader({
  onBack,
  onShare,
  title,
}: {
  onBack: () => void;
  onShare: () => void;
  title: string;
}) {
  return (
    <>
      <div className="lg:hidden shrink-0 h-14 flex items-center justify-between px-4 bg-white border-b border-[#E8E2DA]">
        <button
          onClick={onBack}
          className="w-10 h-10 flex items-center justify-center text-[#121B35] active:scale-90 transition-transform"
          aria-label="뒤로가기"
        >
          <i className="ri-arrow-left-s-line text-xl" />
        </button>

        <span className="absolute left-1/2 -translate-x-1/2 text-[15px] font-semibold text-[#121B35] truncate max-w-[60%]">
          {title}
        </span>

        <button
          onClick={onShare}
          className="w-10 h-10 flex items-center justify-center text-[#121B35] active:scale-90 transition-transform"
          aria-label="공유하기"
        >
          <i className="ri-share-line text-lg" />
        </button>
      </div>

      <div className="hidden lg:block shrink-0 h-16 bg-white border-b border-[#E8E2DA]">
        <div className="max-w-[1200px] mx-auto px-6 h-full flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={onBack}
              className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-[#F7F2EA] transition-colors"
            >
              <i className="ri-close-line text-xl text-[#121B35]" />
            </button>

            <h1 className="text-[17px] font-semibold text-[#121B35]">
              {title}
            </h1>
          </div>

          <button
            onClick={onShare}
            className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-[#F7F2EA] transition-colors"
          >
            <i className="ri-share-line text-lg text-[#121B35]" />
          </button>
        </div>
      </div>
    </>
  );
}

function CategoryFilter({
  categories,
  activeCategory,
  onChange,
  onToggleGrid,
  isGrid,
}: {
  categories: LookbookCategory[];
  activeCategory: string;
  onChange: (id: string) => void;
  onToggleGrid: () => void;
  isGrid: boolean;
}) {
  return (
    <div className="shrink-0 bg-white border-b border-[#E8E2DA]">
      <div className="max-w-[1200px] mx-auto px-4 lg:px-6 h-12 flex items-center justify-between">
        <div className="flex gap-2 overflow-x-auto scrollbar-hide items-center">
          {categories.map((cat) => {
            const isActive = activeCategory === cat.id;

            return (
              <button
                key={cat.id}
                onClick={() => onChange(cat.id)}
                className={`shrink-0 px-3 py-1.5 rounded-full text-[13px] font-medium transition-colors whitespace-nowrap ${
                  isActive
                    ? 'bg-[#121B35] text-white'
                    : 'text-[#536079] hover:text-[#121B35]'
                }`}
              >
                {cat.label}
                <span
                  className={`ml-1 ${
                    isActive ? 'text-[#B9965B]' : 'text-[#9AA3B2]'
                  }`}
                >
                  {cat.count}
                </span>
              </button>
            );
          })}
        </div>

        <button
          onClick={onToggleGrid}
          className="shrink-0 ml-3 flex items-center gap-1 text-[13px] text-[#536079] hover:text-[#121B35] transition-colors whitespace-nowrap"
        >
          <i className={`ri-${isGrid ? 'image-line' : 'grid-fill'} text-sm`} />
          {isGrid ? '사진 보기' : '전체보기'}
        </button>
      </div>
    </div>
  );
}

function PhotoViewer({
  photo,
  currentIndex,
  totalCount,
  filteredPhotos,
  onPrev,
  onNext,
  onThumbnailClick,
}: {
  photo: LookbookPhoto;
  currentIndex: number;
  totalCount: number;
  filteredPhotos: LookbookPhoto[];
  onPrev: () => void;
  onNext: () => void;
  onThumbnailClick: (idx: number) => void;
}) {
  return (
    <div className="flex-1 min-h-0 flex flex-col lg:flex-row lg:overflow-hidden">
      <div className="flex-1 min-h-0 relative bg-[#F9F6F0]">
        <img
          src={photo.src}
          alt={photo.title}
          className="w-full h-full object-contain"
          draggable={false}
        />

        <div className="absolute top-3 right-3 bg-black/50 text-white text-[13px] px-3 py-1 rounded-full font-medium">
          {currentIndex + 1} / {totalCount}
        </div>

        {totalCount > 1 && (
          <button
            onClick={onPrev}
            className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-white/80 hover:bg-white rounded-full text-[#121B35] transition-colors shadow-sm"
            aria-label="이전 사진"
          >
            <i className="ri-arrow-left-s-line text-lg" />
          </button>
        )}

        {totalCount > 1 && (
          <button
            onClick={onNext}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-white/80 hover:bg-white rounded-full text-[#121B35] transition-colors shadow-sm"
            aria-label="다음 사진"
          >
            <i className="ri-arrow-right-s-line text-lg" />
          </button>
        )}
      </div>

      <div className="shrink-0 lg:hidden bg-white border-t border-[#E8E2DA]">
        <div className="px-4 py-3">
          <div className="flex items-center gap-2 mb-1">
            <span className="bg-[#F7F2EA] text-[#121B35] text-[11px] px-2.5 py-0.5 rounded-full font-medium">
              {photo.categoryLabel}
            </span>
          </div>

          <h3 className="text-[15px] font-semibold text-[#121B35] leading-snug">
            {photo.title}
          </h3>

          <p className="text-[13px] text-[#536079] leading-[1.6] mt-0.5 line-clamp-2">
            {photo.description}
          </p>
        </div>

        <div className="px-4 pb-3">
          <div className="flex gap-2 overflow-x-auto scrollbar-hide">
            {filteredPhotos.map((p, i) => (
              <button
                key={p.id}
                onClick={() => onThumbnailClick(i)}
                className={`shrink-0 w-12 h-12 rounded-md overflow-hidden transition-all ${
                  i === currentIndex
                    ? 'ring-2 ring-[#121B35]'
                    : 'opacity-60 hover:opacity-100'
                }`}
              >
                <img
                  src={p.thumbnailSrc || p.src}
                  alt={p.title}
                  className="w-full h-full object-cover"
                />
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="hidden lg:block w-[340px] shrink-0 bg-white border-l border-[#E8E2DA] overflow-y-auto">
        <div className="p-5">
          <div className="flex items-center gap-2 mb-3">
            <span className="bg-[#F7F2EA] text-[#121B35] text-xs px-2.5 py-1 rounded-full font-medium">
              {photo.categoryLabel}
            </span>
          </div>

          <h3 className="text-lg font-semibold text-[#121B35] leading-snug">
            {photo.title}
          </h3>

          <p className="text-sm text-[#536079] leading-[1.7] mt-2">
            {photo.description}
          </p>
        </div>

        <div className="px-5 pb-5">
          <p className="text-[11px] font-medium text-[#536079] mb-2">
            같은 카테고리 사진
          </p>

          <div className="flex flex-wrap gap-2">
            {filteredPhotos.map((p, i) => (
              <button
                key={p.id}
                onClick={() => onThumbnailClick(i)}
                className={`w-14 h-14 rounded-md overflow-hidden transition-all ${
                  i === currentIndex
                    ? 'ring-2 ring-[#121B35]'
                    : 'opacity-60 hover:opacity-100'
                }`}
              >
                <img
                  src={p.thumbnailSrc || p.src}
                  alt={p.title}
                  className="w-full h-full object-cover"
                />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function PhotoGrid({
  photos,
  onPhotoClick,
  currentPhotoId,
}: {
  photos: LookbookPhoto[];
  onPhotoClick: (photo: LookbookPhoto) => void;
  currentPhotoId: string;
}) {
  return (
    <div className="flex-1 min-h-0 overflow-y-auto bg-[#F7F2EA]">
      <div className="max-w-[1200px] mx-auto px-4 lg:px-6 py-4">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-1.5 lg:gap-2">
          {photos.map((photo) => (
            <button
              key={photo.id}
              onClick={() => onPhotoClick(photo)}
              className={`relative aspect-square rounded-lg overflow-hidden bg-[#E8E2DA] transition-all ${
                photo.id === currentPhotoId ? 'ring-2 ring-[#121B35]' : ''
              }`}
            >
              <img
                src={photo.thumbnailSrc || photo.src}
                alt={photo.title}
                className="w-full h-full object-cover"
              />

              <span className="absolute bottom-1 left-1 bg-black/50 text-white text-[10px] px-1.5 py-0.5 rounded">
                {photo.categoryLabel}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function LookbookPage() {
  const navigate = useNavigate();
  const { shopSlug } = useParams<{ shopSlug: string }>();

  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedIdx, setSelectedIdx] = useState(0);
  const [viewMode, setViewMode] = useState<'viewer' | 'grid'>('viewer');

  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [data, setData] = useState<PartnerShopLookbookData | null>(null);

  useEffect(() => {
    if (!shopSlug) {
      setErrorMessage('업체 주소가 올바르지 않습니다.');
      setLoading(false);
      return;
    }

    let ignore = false;

    async function load() {
      setLoading(true);
      setErrorMessage('');

      try {
        const result = await getPartnerShopLookbookBySlug(shopSlug);

        if (ignore) return;

        setData(result);
        setActiveCategory('all');
        setSelectedIdx(0);
        setViewMode('viewer');
      } catch (error) {
        if (ignore) return;

        setErrorMessage(
          error instanceof Error
            ? error.message
            : '룩북을 불러오지 못했습니다.'
        );
      } finally {
        if (!ignore) {
          setLoading(false);
        }
      }
    }

    load();

    return () => {
      ignore = true;
    };
  }, [shopSlug]);

  const photos = data?.photos || [];
  const categories = data?.categories || [
    {
      id: 'all',
      label: '전체',
      count: 0,
    },
  ];

  const filtered = useMemo(() => {
    if (activeCategory === 'all') return photos;
    return photos.filter((photo) => photo.category === activeCategory);
  }, [activeCategory, photos]);

  const current = filtered[selectedIdx] ?? filtered[0] ?? null;

  useEffect(() => {
    if (selectedIdx >= filtered.length) {
      setSelectedIdx(0);
    }
  }, [filtered.length, selectedIdx]);

  const handleCategoryChange = useCallback((id: string) => {
    setActiveCategory(id);
    setSelectedIdx(0);
    setViewMode('viewer');
  }, []);

  const handlePrev = useCallback(() => {
    setSelectedIdx((prev) => {
      if (filtered.length === 0) return 0;
      return (prev - 1 + filtered.length) % filtered.length;
    });
  }, [filtered.length]);

  const handleNext = useCallback(() => {
    setSelectedIdx((prev) => {
      if (filtered.length === 0) return 0;
      return (prev + 1) % filtered.length;
    });
  }, [filtered.length]);

  const handleThumbnailClick = useCallback((index: number) => {
    setSelectedIdx(index);
  }, []);

  const handleGridClick = useCallback(
    (photo: LookbookPhoto) => {
      const index = filtered.findIndex((item) => item.id === photo.id);

      setSelectedIdx(index >= 0 ? index : 0);
      setViewMode('viewer');
    },
    [filtered]
  );

  const handleToggleGrid = useCallback(() => {
    setViewMode((prev) => (prev === 'viewer' ? 'grid' : 'viewer'));
  }, []);

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const partnerShopName =
    data?.partnerShop.displayName || data?.partnerShop.shopName || '업체';

  const handleShare = useCallback(async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: `${partnerShopName} 브랜드 룩북`,
          url: window.location.href,
        });
      } else {
        await navigator.clipboard.writeText(window.location.href);
      }
    } catch {
      // noop
    }
  }, [partnerShopName]);

  if (loading) {
    return (
      <div className="h-[100dvh] flex flex-col bg-[#F7F2EA]">
        <LookbookHeader
          onBack={handleBack}
          onShare={handleShare}
          title="브랜드 룩북"
        />

        <div className="flex-1 flex items-center justify-center text-[#536079] text-sm">
          룩북을 불러오는 중입니다.
        </div>
      </div>
    );
  }

  if (errorMessage || !data) {
    return (
      <div className="h-[100dvh] flex flex-col bg-[#F7F2EA]">
        <LookbookHeader
          onBack={handleBack}
          onShare={handleShare}
          title="브랜드 룩북"
        />

        <div className="flex-1 flex items-center justify-center px-6">
          <div className="bg-white rounded-2xl border border-[#E8E2DA] p-6 max-w-[420px] w-full text-center">
            <p className="text-[15px] font-semibold text-[#121B35]">
              룩북을 불러오지 못했습니다.
            </p>

            <p className="text-[13px] text-[#536079] mt-2">
              {errorMessage || '잠시 후 다시 시도해 주세요.'}
            </p>

            <button
              onClick={handleBack}
              className="mt-5 h-10 px-4 rounded-full bg-[#121B35] text-white text-[13px] font-semibold"
            >
              돌아가기
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!current) {
    return (
      <div className="h-[100dvh] flex flex-col bg-[#F7F2EA]">
        <LookbookHeader
          onBack={handleBack}
          onShare={handleShare}
          title={`${partnerShopName} 브랜드 룩북`}
        />

        <div className="flex-1 flex items-center justify-center text-[#536079] text-sm">
          룩북 사진이 없습니다.
        </div>
      </div>
    );
  }

  return (
    <div className="h-[100dvh] flex flex-col overflow-hidden bg-[#F7F2EA]">
      <LookbookHeader
        onBack={handleBack}
        onShare={handleShare}
        title={`${partnerShopName} 브랜드 룩북`}
      />

      <CategoryFilter
        categories={categories}
        activeCategory={activeCategory}
        onChange={handleCategoryChange}
        onToggleGrid={handleToggleGrid}
        isGrid={viewMode === 'grid'}
      />

      {viewMode === 'viewer' ? (
        <PhotoViewer
          photo={current}
          currentIndex={selectedIdx}
          totalCount={filtered.length}
          filteredPhotos={filtered}
          onPrev={handlePrev}
          onNext={handleNext}
          onThumbnailClick={handleThumbnailClick}
        />
      ) : (
        <PhotoGrid
          photos={filtered}
          onPhotoClick={handleGridClick}
          currentPhotoId={current.id}
        />
      )}
    </div>
  );
}